const REVEAL_SELECTOR = '#MainContent .text-block, #MainContent .rte';

/** @type {IntersectionObserver | undefined} */
let revealObserver;

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function markVisible(target) {
  target.classList.add('bz-scroll-reveal--visible');
  revealObserver?.unobserve(target);
}

function revealNodes() {
  const main = document.querySelector('#MainContent');
  if (!main) return;

  const nodes = main.querySelectorAll(REVEAL_SELECTOR);
  if (!nodes.length) return;

  if (prefersReducedMotion()) {
    nodes.forEach((node) => node.classList.add('bz-scroll-reveal', 'bz-scroll-reveal--visible'));
    return;
  }

  /** @type {Element[]} */
  const pending = [];

  nodes.forEach((node) => {
    if (node.closest('.hero, .hero__container, .bz-scroll-reveal--skip')) return;
    if (node.parentElement?.closest('.text-block, .rte')) return;
    node.classList.add('bz-scroll-reveal');
    if (!node.classList.contains('bz-scroll-reveal--visible')) pending.push(node);
  });

  if (!pending.length) return;

  const sectionCounts = new Map();
  pending.forEach((node) => {
    const section = node.closest('.shopify-section') || main;
    const index = sectionCounts.get(section) || 0;
    sectionCounts.set(section, index + 1);
    node.style.setProperty('--bz-reveal-delay', `${Math.min(index, 4) * 90}ms`);
  });

  if (!revealObserver) {
    revealObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) markVisible(entry.target);
        }
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.18 }
    );
  }

  pending.forEach((node) => revealObserver.observe(node));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', revealNodes, { once: true });
} else {
  revealNodes();
}

document.addEventListener('shopify:section:load', revealNodes);
